<p-toast key="tst"></p-toast>
<div class="p-grid">
    <div class="p-col-12">
        <div class="card">
            <h5>{{ 'titulo.titulo' | translate }}</h5>

            <p-messages [value]="msgs"></p-messages>
            <div class="p-fluid p-formgrid p-grid">
                <div class="p-col-12">
                    <div class="p-fluid p-formgrid p-grid">

                        <div class="p-field p-col-12 p-md-3">
                            <h6>{{ 'titulo.nossonumero' | translate }}</h6>
                            <input
                                id="nossoNumero"
                                type="text"
                                pInputText
                                [(ngModel)]="filter.codNossoNumero"
                                (keypress)="numberOnly($event)"
                                maxlength="25"
                            />
                        </div>

                        <div class="p-field p-col-12 p-md-3">
                            <h6>{{ 'titulo.seuNumero' | translate }}</h6>
                            <input
                                id="seuNumero"
                                type="text"
                                pInputText
                                [(ngModel)]="filterSacado.seuNumero"
                                maxlength="16"
                            />
                        </div>

                        <div class="p-field p-col-12 p-md-3"
                            *ngIf="(perfil != null && (perfil.nmePerfil === 'ADMTIVIT' || perfil.nmePerfil === 'MNGTIVIT' || perfil.nmePerfil === 'OPRTIVIT')) ">
                            <h6>{{ 'titulo.documentocedente' | translate }}</h6>
                            <input id="documentoCedente" type="text" pInputText [(ngModel)]="filterCedente.codInscricao"
                                maxlength="16" />
                        </div>

                        <div class="p-field p-col-12 p-md-3">
                            <h6>{{ 'titulo.documentosacado' | translate }}</h6>
                            <input id="documentoSacado" type="text" pInputText [(ngModel)]="filterSacado.documento"
                                maxlength="16" />
                        </div>

                    </div>

                </div>





                <div class="p-field p-col-12 p-md-3">
                    <h6>{{ 'titulo.dataVencInicial' | translate }}</h6>
                    <span class="p-float-label">
                        <p-calendar [showIcon]="true" inputId="dtaVencimentoInicial"
                            [(ngModel)]="filter.dtaVencimentoInicial" [locale]="pt" dateFormat="dd/mm/yy"></p-calendar>
                    </span>
                </div>

                <div class="p-field p-col-12 p-md-3">
                    <h6>{{ 'titulo.dataVencFinal' | translate }}</h6>
                    <span class="p-float-label">
                        <p-calendar [showIcon]="true" inputId="dtaVencimentoFinal"
                            [(ngModel)]="filter.dtaVencimentoFinal" [locale]="pt" dateFormat="dd/mm/yy"></p-calendar>
                    </span>
                </div>

                <div class="p-field p-col-12 p-md-3">
                    <h6>{{ 'titulo.dataliquidInicial' | translate }}</h6>
                    <span class="p-float-label">
                        <p-calendar [showIcon]="true" inputId="dtaLiquidacaoInicial"
                            [(ngModel)]="filter.dtaLiquidacaoInicial" [locale]="pt" dateFormat="dd/mm/yy"></p-calendar>
                    </span>
                </div>

                <div class="p-field p-col-12 p-md-3">
                    <h6>{{ 'titulo.dataliquidFinal' | translate }}</h6>
                    <span class="p-float-label">
                        <p-calendar [showIcon]="true" inputId="dtaLiquidacaoFinal"
                            [(ngModel)]="filter.dtaLiquidacaoFinal" [locale]="pt" dateFormat="dd/mm/yy"></p-calendar>
                    </span>
                </div>

                <div class="p-field p-col-12 p-md-3">
                    <h6>{{ 'titulo.status' | translate }}</h6>
                    <p-autoComplete [(ngModel)]="statusBoletoSel" [suggestions]="filteredStatusBoleto"
                        (completeMethod)="filterStatusBoleto($event)" field="desStatusBoleto" [dropdown]="true"
                        id="statusBoleto">
                    </p-autoComplete>
                </div>

                <div class="p-field p-col-12 p-md-3">
                    <h6>{{ 'menu.manterBanco' | translate }}</h6>
                    <p-autoComplete
                        [(ngModel)]="bancoSel"
                        [suggestions]="filteredBanco"
                        (completeMethod)="filterBanco($event)"
                        field="nmeBanco"
                        [dropdown]="true"
                        id="codBanco">
                    </p-autoComplete>
                </div>

                            <!--div class="p-field p-col-12 p-md-3">
                                <h6>{{ 'menu.manterCarteira' | translate }}</h6>
                                <p-autoComplete [(ngModel)]="bancoSel" [suggestions]="filteredCarteira"
                                (completeMethod)="filterCarteira($event)" field="desCarteiraBanco" [dropdown]="true" id="id">
                                </p-autoComplete>
                            </div-->

                <div class="p-field p-col-12 p-md-3">
                    <h6>{{ 'titulo.convenio' | translate }}</h6>
                    <input id="convenio" type="text" pInputText [(ngModel)]="filter.convenio"
                        (keypress)="numberOnly($event)" maxlength="25" />
                </div>

                <div class="p-field p-col-12 p-md-3">
                    <h6>{{ 'titulo.envioPrimeiraVia' | translate }}</h6>
                    <p-dropdown [options]="envioPrimeiraVia" [(ngModel)]="filter.envioPrimeiraVia" optionLabel="name"
                        optionValue="code" placeholder="{{ 'titulo.selecione' | translate }}"></p-dropdown>
                </div>

                <div class="p-field p-col-12 p-md-3">
                    <h6>{{ 'titulo.nmeCedente' | translate }}</h6>
                    <input
                        id="nmeCedente"
                        type="text"
                        pInputText
                        [(ngModel)]="filterCedente.nmeCedente"
                    />
                </div>

                <div class="p-field p-col-12 p-md-3">
                    <h6>{{ 'titulo.nmeSacado' | translate }}</h6>
                    <input
                        id="nmeSacado"
                        type="text"
                        pInputText
                        [(ngModel)]="filterSacado.nmeSacado"
                    />
                </div>

                <div class="p-field p-col-12 p-md-3">
                    <h6>{{ 'titulo.nmeBairroSacado' | translate }}</h6>
                    <input
                        id="nmeBairroSacado"
                        type="text"
                        pInputText
                        [(ngModel)]="filterSacado.nmeBairroSacado"
                    />
                </div>

                <div class="p-field p-col-12 p-md-3">
                    <h6>{{ 'titulo.nmeEnderecoSacado' | translate }}</h6>
                    <input
                        id="nmeEnderecoSacado"
                        type="text"
                        pInputText
                        [(ngModel)]="filterSacado.nmeEnderecoSacado"
                    />
                </div>

                <div class="p-field p-col-12 p-md-3">
                    <h6>{{ 'titulo.desTipoInscricao' | translate }}</h6>
                    <p-autoComplete
                        [(ngModel)]="tipoInscricaoSel"
                        [suggestions]="filteredTipoInscricao"
                        (completeMethod)="filterTipoInscricao($event)"
                        field="desTipoInscricao"
                        [dropdown]="true"
                        id="codTipoInscricao">
                    </p-autoComplete>
                </div>

                <div class="p-field p-col-12 p-md-3">
                    <h6>{{ 'titulo.codUfSacado' | translate }}</h6>
                    <p-autoComplete
                        [(ngModel)]="estadoSel"
                        [suggestions]="filteredEstado"
                        (completeMethod)="filterEstado($event)"
                        field="uf"
                        [dropdown]="true"
                        id="id">
                    </p-autoComplete>
                </div>

                <div class="p-field p-col-12 p-md-3">
                    <h6>{{ 'titulo.dscEmail' | translate }}</h6>
                    <input
                        id="dscEmail"
                        type="text"
                        pInputText
                        [(ngModel)]="filterSacado.dscEmail"
                    />
                </div>

            </div>
        </div>

        <button pButton pRipple type="button" label="{{ 'label.pesquisar' | translate }}"
            (click)="pesquisarTituloPage()" class="p-mr-2"></button>
        <button pButton pRipple type="button" label="{{ 'label.limparformulario' | translate }}"
            (click)="limparFormulario()" class="p-mr-2"></button>
                        <!-- exportação antiga antes era somente excel
                            <button pButton pRipple type="button" label="{{ 'label.exportar' | translate }}" (click)="downloadFile()" class="p-mr-2" *ngIf="titulos != null && titulos.length > 0"></button>
                        -->
        <span *ngIf="titulos != null && titulos.length > 0" class="p-input-icon-left">
            <p-splitButton label="Exportar" icon="pi pi-clone" [model]="exportOptions"
                styleClass="p-button-info p-mr-2"></p-splitButton>
        </span>
    </div>

    <div class="p-col-12" *ngIf="pesquisandoProgress === true">
        {{ 'label.carregando' | translate }}
        <p-progressBar mode="indeterminate" [style]="{'height': '30px'}"></p-progressBar>
    </div>
    <div class="p-col-12">
        <p-table #dt [value]="titulos" [(selection)]="selectedPagamentos" dataKey="codTitulo"
            styleClass="p-datatable-customers" [rowHover]="true" [rows]="10" [paginator]="true" [filterDelay]="0"
            [globalFilterFields]="['codTitulo', 'bancoResponsavel.nmeBanco', 'cedente.nmeCedente','sacado.nmeSacado','codNossoNumero','dtaVencimento',
                     'vlrTitulo', 'dtaPagamento', 'statusBoleto.desStatusBoleto']" (onLazyLoad)="nextPage($event)"
            [totalRecords]="totalRecords" [loading]="loading"
            [currentPageReportTemplate]="'{currentPage} of {totalPages}'" [showCurrentPageReport]="true" [lazy]="true"
            [rowsPerPageOptions]="[5, 10, 20, 100]">

            <ng-template pTemplate="caption">
                <div
                    class="p-d-flex p-flex-column p-flex-md-row p-jc-md-between table-header">Pagamentos
                    <span class="p-input-icon-left">
                        <span><i class="pi pi-file-pdf" style="color: red;padding-left:5px"></i> Exibir Seleção -
                            Geração de Boletos em PDF </span>
                        <p-inputSwitch id="inputAtivo" name="inputAtivo"
                            (click)="alternarVisualizacaoImpressaoComprovante()"></p-inputSwitch>
                    </span>
                    <span class="p-input-icon-left">
                        <p-splitButton label="Exportar" icon="pi pi-clone" [model]="exportOptions"
                            styleClass="p-button-info p-mr-2 p-mb-2"></p-splitButton>
                    </span>
                </div>
            </ng-template>

            <ng-template pTemplate="header">
                <tr>
                    <th>
                        <div class="p-d-flex p-jc-between p-ai-center" style="font-weight: bold;">
                            <i class="pi pi-file-pdf" style="color: red;padding-left:5px"></i>
                        </div>
                    </th>
                    <th pSortableColumn="bancoResponsavel.nmeBanco">
                        <div class="p-d-flex p-jc-between p-ai-center">
                            {{ 'titulo.banco' | translate }}
                            <p-sortIcon field="bancoResponsavel.nmeBanco"></p-sortIcon>
                            <p-columnFilter type="numeric" field="bancoResponsavel.nmeBanco" display="menu"
                                class="p-ml-auto"></p-columnFilter>
                        </div>
                    </th>
                    <th pSortableColumn="cedente.nmeCedente">
                        <div class="p-d-flex p-jc-between p-ai-center">
                            {{ 'titulo.cedente' | translate }}
                            <p-sortIcon field="cedente.nmeCedente"></p-sortIcon>
                            <p-columnFilter type="text" field="cedente.nmeCedente" display="menu"
                                class="p-ml-auto"></p-columnFilter>
                        </div>
                    </th>
                    <th pSortableColumn="sacado.nmeSacado">
                        <div class="p-d-flex p-jc-between p-ai-center">
                            {{ 'titulo.sacado' | translate }}
                            <p-sortIcon field="sacado.nmeSacado"></p-sortIcon>
                            <p-columnFilter type="text" field="sacado.nmeSacado" display="menu"
                                class="p-ml-auto"></p-columnFilter>
                        </div>
                    </th>
                    <th pSortableColumn="codNossoNumero">
                        <div class="p-d-flex p-jc-between p-ai-center">
                            {{ 'titulo.nossonumero' | translate }}
                            <p-sortIcon field="codNossoNumero"></p-sortIcon>
                            <p-columnFilter type="text" field="codNossoNumero" display="menu"
                                class="p-ml-auto"></p-columnFilter>
                        </div>
                    </th>
                    <th pSortableColumn="dtaVencimento">
                        <div class="p-d-flex p-jc-between p-ai-center">
                            {{ 'titulo.dtaVencimento' | translate }}
                            <p-sortIcon field="dtaVencimento"></p-sortIcon>
                            <p-columnFilter type="date" field="dtaVencimento" display="menu"
                                class="p-ml-auto"></p-columnFilter>
                        </div>
                    </th>
                    <th pSortableColumn="vlrTitulo">
                        <div class="p-d-flex p-jc-between p-ai-center">
                            {{ 'titulo.vlrTitulo' | translate }}
                            <p-sortIcon field="vlrTitulo"></p-sortIcon>
                            <p-columnFilter type="numeric" field="vlrTitulo" display="menu"
                                class="p-ml-auto"></p-columnFilter>
                        </div>
                    </th>
                    <th pSortableColumn="dtaPagamento">
                        <div class="p-d-flex p-jc-between p-ai-center">
                            {{ 'titulo.dtaLiquidacao' | translate }}
                            <p-sortIcon field="dtaPagamento"></p-sortIcon>
                            <p-columnFilter type="date" field="dtaPagamento" display="menu"
                                class="p-ml-auto"></p-columnFilter>
                        </div>
                    </th>
                    <th pSortableColumn="statusBoleto.desStatusBoleto">
                        <div class="p-d-flex p-jc-between p-ai-center">
                            {{ 'label.status' | translate }}
                            <p-sortIcon field="statusBoleto.desStatusBoleto"></p-sortIcon>
                            <p-columnFilter type="date" field="statusBoleto.desStatusBoleto" display="menu"
                                class="p-ml-auto"></p-columnFilter>
                        </div>
                    </th>
                    <th style="width: 12rem"></th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-titulo>
                <tr class="p-selectable-row">
                    <td *ngIf="!exibirCheckBoxAprovacao && titulo.statusBoleto.codStatusBoleto == 8">
                        <p-tableCheckbox [value]="titulo" (click)="checkedListLoteComprovantes()"></p-tableCheckbox>
                        <i class="pi pi-file-pdf" style="color: red"></i>
                    </td>
                    <td *ngIf="!exibirCheckBoxAprovacao && titulo.statusBoleto.codStatusBoleto == 3">
                        <p-tableCheckbox [value]="titulo" (click)="checkedListLoteComprovantes()"></p-tableCheckbox>
                        <i class="pi pi-file-pdf" style="color: red"></i>
                    </td>
                    <td
                        *ngIf="!exibirCheckBoxAprovacao && titulo.statusBoleto.codStatusBoleto != 8 && titulo.statusBoleto.codStatusBoleto != 3">
                        <i class="pi pi-check" pTooltip="Não Liquidado/Registrado"></i>
                    </td>

                    <td *ngIf="exibirCheckBoxAprovacao && titulo.statusBoleto.codStatusBoleto == 8">
                        <i class="pi pi-check" pTooltip="Liquidado"></i>
                    </td>
                    <td *ngIf="exibirCheckBoxAprovacao && titulo.statusBoleto.codStatusBoleto == 3">
                        <i class="pi pi-check" pTooltip="Registrado"></i>
                    </td>
                    <td
                        *ngIf="exibirCheckBoxAprovacao && titulo.statusBoleto.codStatusBoleto != 8 && titulo.statusBoleto.codStatusBoleto != 3">
                        <i class="pi pi-check" pTooltip="Não Liquidado/Registrado"></i>
                    </td>

                    <td>
                        <span class="p-column-title"></span>
                        {{titulo.bancoResponsavel.nmeBanco}}
                    </td>
                    <td>
                        <span class="p-column-title"></span>
                        {{titulo.cedente.nmeCedente}}
                    </td>
                    <td>
                        <span class="p-column-title"></span>
                        {{titulo.sacado.nmeSacado}}
                    </td>
                    <td>
                        <span class="p-column-title"></span>
                        {{titulo.codNossoNumero}}
                    </td>
                    <td>
                        <span class="p-column-title"></span>
                        {{titulo.dtaVencimento | date: 'dd/MM/yyyy'}}
                    </td>
                    <td>
                        <span class="p-column-title"></span>
                        {{titulo.vlrTitulo | currency:'BRL'}}
                    </td>
                    <td>
                        <span class="p-column-title"></span>
                        {{titulo.statusBoleto.codStatusBoleto === 8 ? (titulo.dtaPagamento | date: 'dd/MM/yyyy') :
                        null}}
                        {{titulo.statusBoleto.codStatusBoleto === 25 ? (titulo.dtaPagamento | date: 'dd/MM/yyyy') :
                        null}}
                    </td>
                    <td>
                        <span class="p-column-title"></span>
                        <span
                            [class]="'titulo-badge titulo-status-' + titulo.statusBoleto.desStatusBoletoTrimmed.toLowerCase()">{{titulo.statusBoleto.desStatusBoleto}}</span>
                    </td>
                    <td>
                        <p-button type="button" icon="pi pi-search" class="p-button-rounded p-button-success p-mr-2"
                            (click)="viewBoleto(titulo)" alt="Visualizar Boleto"
                            *ngIf="titulo.statusBoleto.desStatusBoleto === 'Registrado' || titulo.statusBoleto.desStatusBoleto === 'Liquidado'"></p-button>

                        <button pButton pRipple icon="pi pi-envelope" class="p-button-rounded p-button-success p-mr-2"
                            (click)="sendEditBanco(titulo)" *ngIf="titulo.statusBoleto.desStatusBoleto === 'Registrado'"
                            alt="Enviar 2 via"></button>

                        <button pButton pRipple icon="pi pi-eye" class="p-button-rounded p-button-warning p-mr-2"
                            (click)="detalhesTitulo(titulo)" alt="Enviar 2 via"></button>
                    </td>
                </tr>
            </ng-template>

        </p-table>


    </div>
    <div class="p-col-12">
        <p-dialog id="sacadoDialogPrint" [(visible)]="sacadoDialog" height="auto"
            header="{{ 'titulo.titulo' | translate }}" [modal]="true" styleClass="p-fluid">
            <ng-template pTemplate="content">
                <div class="p-field page-content" id="imgTitulo">
                    <img [src]="url" />
                </div>
            </ng-template>
            <ng-template pTemplate="footer">
                <button pButton pRipple label="{{ 'label.cancelar' | translate }}" icon="pi pi-times"
                    class="p-button-text" (click)="hideDialogSacadoDialog()"></button>
                <button pButton pRipple label="{{ 'label.download' | translate }}" icon="pi pi-times"
                    class="p-button-text" (click)="downloadPdf()"></button>
            </ng-template>
        </p-dialog>
    </div>

    <div class="p-col-12">
        <p-dialog [(visible)]="tituloDialog" [style]="{width: '450px'}" header="{{ 'titulo.segundavia' | translate }}"
            [modal]="true" styleClass="p-fluid">
            <ng-template pTemplate="content">
                <div class="p-field">
                    <label for="name">{{ 'titulo.nomesacado' | translate }}</label>
                    <input type="text" pInputText id="nmeSacado" [(ngModel)]="titulo.sacado.nmeSacado" readonly />
                </div>
                <div class="p-field">
                    <label for="name">{{ 'titulo.email' | translate }}</label>
                    <input type="text" pInputText id="emailSacado" [(ngModel)]="emailSacado.nmeEmail" required
                        autofocus />
                    <small class="p-invalid" *ngIf="submitted && !emailSacado.nmeEmail">E-mail do banco ?
                        obrigat?rio.</small>
                </div>
            </ng-template>
            <ng-template pTemplate="footer">
                <button pButton pRipple label="{{ 'label.cancelar' | translate }}" icon="pi pi-times"
                    class="p-button-text" (click)="hideDialog()"></button>
                <button pButton pRipple label="{{ 'label.enviaremail' | translate }}" icon="pi pi-check"
                    class="p-button-text" (click)="sendEmail(titulo)"></button>
            </ng-template>
        </p-dialog>
    </div>

    <div class="p-col-12">
        <p-dialog [(visible)]="emailDialog" [style]="{width: '450px'}" header="{{ 'titulo.enviaremail' | translate }}"
            [modal]="true" styleClass="p-fluid">
            <ng-template pTemplate="content">
                <div class="p-field">
                    <label for="name">{{ 'titulo.email' | translate }}</label>
                    <input type="text" pInputText id="sendEmailInput" [(ngModel)]="sendEmailInput" required
                        autofocus />
                    <small class="p-invalid" *ngIf="submitted && !sendEmailInput">E-mail do banco ?
                        obrigat?rio.</small>
                </div>
            </ng-template>
            <ng-template pTemplate="footer">
                <button pButton pRipple label="{{ 'label.cancelar' | translate }}" icon="pi pi-times"
                    class="p-button-text" (click)="hideDialog()"></button>
                <button pButton pRipple label="{{ 'label.enviaremail' | translate }}" icon="pi pi-check"
                    class="p-button-text" (click)="enviarEmailArquivoUnico()"></button>
            </ng-template>
        </p-dialog>
    </div>

    <div class="p-col-12">
        <p-dialog [(visible)]="tituloDetalhe" [style]="{width: '450px'}"
            header="{{ 'titulo.detalhesTitulo' | translate }}" [modal]="true" styleClass="p-fluid">
            <ng-template pTemplate="content">
                <div class="p-field">
                    <label for="nmeSacado">{{ 'titulo.nomesacado' | translate }}</label>
                    <input type="text" pInputText id="nmeSacado" [(ngModel)]="titulo.sacado.nmeSacado" readonly />
                </div>
                <div class="p-field">
                    <label for="documentoSacado">{{ 'titulo.documentoSacado' | translate }}</label>
                    <input type="text" pInputText id="documentoSacado" [(ngModel)]="titulo.sacado.codInscricaoSacado"
                        readonly />
                </div>
                <div class="p-field">
                    <label for="nroDocumento">{{ 'titulo.nroDocumento' | translate }}</label>
                    <input type="text" pInputText id="nroDocumento" [(ngModel)]="titulo.nroDocumento" readonly />
                </div>
                <div class="p-field">
                    <label for="dtaCredito">{{ 'titulo.dtaCredito' | translate }}</label>
                    <input type="text" pInputText id="dtaCredito"
                        value="{{titulo.dataRetornoEfetivacao | date: 'dd/MM/yyyy'}}" readonly />
                </div>
                <div class="p-field">
                    <label for="vlrRetornoPago">{{ 'titulo.vlrRetornoPago' | translate }}</label>
                    <input type="text" pInputText id="vlrRetornoPago" value="{{titulo.vlrRetornoPago | currency:'BRL'}}"
                        readonly />
                </div>

                <div class="p-field">
                    <label for="codigoRejeicao">{{ 'titulo.codigoRejeicao' | translate }}</label>
                    <input type="text" pInputText id="codigoRejeicao" [(ngModel)]="titulo.codRetRejeicao" readonly />
                </div>
                <div class="p-field">
                    <label for="descricaoRejeicao">{{ 'titulo.descricaoRejeicao' | translate }}</label>
                    <input type="text" pInputText id="descricaoRejeicao" [(ngModel)]="titulo.dscRetRejeicao" readonly />
                </div>
            </ng-template>
            <ng-template pTemplate="footer">
                <button pButton pRipple label="{{ 'label.cancelar' | translate }}" icon="pi pi-times"
                    class="p-button-text" (click)="hideDetalhesTituloDialog()"></button>
            </ng-template>
        </p-dialog>

    </div>

</div>
<p-sidebar [(visible)]="bottomSidebarImpressaoComprovantes" [modal]="false" position="bottom">
    <div
        style="display: flex; flex-direction: column; justify-content: left; align-items: left; height: 100%; padding: 0.3rem;">
        <div style="display: flex; justify-content: left; margin-top: 0 0.5rem;">
            <h3>Deseja gerar todos os {{totalPagamentosSelecionados}} boletos selecionados em um
                único arquivo(PDF)?</h3>
        </div>
        <div style="margin-top: 0 0.5rem;">
            <p-radioButton class="p-md-1" label="Sim" name="sim" value="Unico" [(ngModel)]="selecaoPdF"
                inputId="pdfUnico"></p-radioButton>
            <p-radioButton class="p-md-2" label="Não" name="nao" value="Separado" [(ngModel)]="selecaoPdF"
                inputId="pdfSepardo"></p-radioButton>
        </div>
        <span style="margin-top: 0 0.5rem; color: #888888;">*Obs: Ao escolher a opção Não os arquivos serão gerados
            separadamente</span>
        <div style="display: flex; justify-content: left; margin-top: 0 0.5rem;">
            <button [disabled]=" selecaoPdF == undefined " pButton pRipple type="button" label="CONFIRMAR"
                (click)="imprimirComprovantesEmLote()" class="p-button p-button-primary"
                style="margin: 0 0.5rem;"></button>

            <button pButton pRipple type="button" label="CANCELAR" (click)="fecharBottomSidebarImpressaoComprovantes()"
                class="p-button p-button-text p-button-plain" style="margin: 0 0.5rem;"></button>

            <button pButton pRipple type="button" label="ENVIAR POR E-MAIL"
                (click)="sendEditEmail()" class="p-button p-button-primary"
                style="margin: 0 0.5rem;"></button>
        </div>
    </div>
</p-sidebar>
